require('./sidebar.less');

class SidebarController {
    private collapsedArticles;
    private collapsedBasicData;
    private collapsedLines;
    menu;

    constructor(private $state, private ssSideNav, private $scope, private userService, private hasAccessTo) {
        this.collapsedArticles = true;
        this.collapsedBasicData = true;
        this.collapsedLines = true;
        this.menu = ssSideNav;
        this.handleAuthorities();
    }

    handleAuthorities() {
        const hasOrdersAccess = this.hasAccessTo.orders();
        const hasPrognosisAccess = this.hasAccessTo.prognosis();
        const hasExpeditionAccess = this.hasAccessTo.expedition();
        const hasAdminAccess = this.hasAccessTo.administrate();

        this.ssSideNav.setVisibleFor([
            //--- LOS ---
            {
                id: 'los',
                value: hasOrdersAccess || hasPrognosisAccess
            }, {
                id: 'orders',
                value: hasOrdersAccess
            }, {
                id: 'lines',
                value: hasOrdersAccess
            }, {
                id: 'articles',
                value: hasOrdersAccess
            }, {
                id: 'prognosis',
                value: hasPrognosisAccess
            },
            //--- Expedition ---
            {
                id: 'expedition',
                value: hasExpeditionAccess
            },
            //--- Basic Data ---
            {
                id: 'basicDataFunctions',
                value: hasAdminAccess
            }
        ]);
    }
}

class SidebarOptions implements ng.IComponentOptions {
    bindings: any = {
        hideSidebar: '='
    };
    controllerAs = 'c';
    public controller: string = "rkcSidebarController";
    public template: any = require('./sidebar.html');
}

rkcApp.controller("rkcSidebarController", ['$state', 'ssSideNav', '$scope', 'userService', 'hasAccessTo', function ($state, ssSideNav, $scope, userService, hasAccessTo) {
    return new SidebarController($state, ssSideNav, $scope, userService, hasAccessTo);
}])
    .component("rkcSidebar", new SidebarOptions())
    .config(['ssSideNavSectionsProvider', function (ssSideNavSectionsProvider) {
        ssSideNavSectionsProvider.initWithSections([
            {
                id: 'los',
                name: 'LOS',
                type: 'heading',
                children: [
                    {
                        id: 'orders',
                        name: 'Ordreoversikt',
                        type: 'link',
                        state: 'loggedin.orders',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'view_list'
                    }, {
                        id: 'lines',
                        name: 'Linjeoversikt',
                        type: 'link',
                        state: 'loggedin.lines',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'list'
                    }, {
                        id: 'articles',
                        name: 'Varer',
                        type: 'link',
                        state: 'loggedin.articles',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'store'
                    }/*,{
                    id: 'prognosis',
                    name:  'Prognose',
                    type: 'link',
                    state: 'loggedin.prognosis',
                    icon: 'material-icons-for-menu material-icons',
                    ligature: 'multiline_chart'
                },{
                    id: 'notreceived',
                    name:  'Ikke mottatte',
                    type: 'link',
                    state: 'loggedin.notreceived',
                    icon: 'material-icons-for-menu material-icons',
                    ligature: 'warning'
                }*/
                ]
            }, {
                id: 'expedition',
                name: 'Ekspedisjon',
                type: 'heading',
                children: [
                    {
                        id: 'booking_week',
                        name: 'Booking (uke)',
                        type: 'link',
                        state: 'loggedin.expedition_booking_week',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'local_shipping'
                    },
                    {
                        id: 'booking_day',
                        name: 'Booking (dag)',
                        type: 'link',
                        state: 'loggedin.expedition_booking_day',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'local_shipping'
                    }, {
                        id: 'distribution',
                        name: 'Plukkstatus (uke)',
                        type: 'link',
                        state: 'loggedin.expedition_distribution_week',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'content_paste'
                    }, {
                        id: 'distribution',
                        name: 'Plukkstatus (dag)',
                        type: 'link',
                        state: 'loggedin.expedition_distribution_day',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'content_paste'
                    }
                ]
            }, {
                id: 'basicDataFunctions',
                name: 'Stamdata',
                type: 'heading',
                children: [
                    {
                        id: 'users',
                        name: 'Brukere',
                        type: 'link',
                        state: 'loggedin.users',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'group'
                    }, {
                        id: 'parameters',
                        name: 'Parametre',
                        type: 'link',
                        state: 'loggedin.parameters',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'settings'
                    },
                    {
                        id: 'httpTriggers',
                        name: 'Databehandling',
                        type: 'link',
                        state: 'loggedin.httpTriggers',
                        icon: 'material-icons-for-menu material-icons',
                        ligature: 'attachment'
                    }

                ]
            }
        ])
    }]);



/** WEBPACK FOOTER **
 ** ./src/app/components/main/sidebar/sidebar.ts
 **/